import { render, staticRenderFns } from "./forbidden.html?vue&type=template&id=c27dcc0a&scoped=true&"
import script from "./forbidden.vue?vue&type=script&lang=ts&"
export * from "./forbidden.vue?vue&type=script&lang=ts&"
import style0 from "./forbidden.scss?vue&type=style&index=0&id=c27dcc0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27dcc0a",
  null
  
)

export default component.exports